import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NoUserAccess: React.FC = () => {
  
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      textAlign="center"
      padding={2}
    >
      <Typography variant="h4" gutterBottom>
        🚫 Access Denied
      </Typography>
      <Typography variant="body1" marginBottom={2}>
        You do not have the required permissions to access this module.
      </Typography>
    </Box>
  );
};

export default NoUserAccess;
